var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"com-btn-check",class:{ checked: _vm.$checked, disabled: _vm.disabled }},[_c('button',{on:{"click":_vm.handleStatusChange}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"used-icon"},[_c('img',{attrs:{"src":require("@/assets/img/check-btn-used.png"),"alt":""}})])
}]

export { render, staticRenderFns }